import React from 'react';
import { RelayItem } from './types';

interface Props {
  items: Array<RelayItem>;
}

const Relay = (props: Props): React.ReactElement | null => {
  const { items } = props;

  const relay = items[0];

  const parts = relay?.parts ?? [];

  if (parts.length < 1) {
    return null;
  }

  return (
    <div className="schedule">
      <div className="relay-band-list">
        {relay.parts.map((part, index) => (
          <div
            key={index}
            className="item"
            style={{ zIndex: parts.length - index }}
          >
            {/* eslint-disable-next-line jsx-a11y/anchor-has-content */}
            <a href={part.link_to}>
              <img src={part.cover_image!} />
            </a>
            <div className="label-box">
              <a href={part.link_to}>{part.title}</a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Relay;
